module.exports = __webpack_public_path__ + "media/common/statics/lesson_icon/4-9069fb4f4fc36ed24ece0ec6549a4907.png";